'use client'
import React, { FC, ReactNode } from 'react'
import { DeliveryDTO, Option } from 'ecosystem'
import { CustomAssistant } from '#/src/custom/components/CustomAssistant'
import useAppConfig from '#/src/custom/hooks/useAppConfig'
import { useTrackPageView } from 'storefront-modules/third-party'

interface AppComponentProps {
  children: ReactNode
  deliveries?: Option<DeliveryDTO[]>
}

const AppComponent: FC<AppComponentProps> = ({ children, deliveries }) => {
  const appConfig = useAppConfig()
  useTrackPageView({ categories: appConfig.categories })

  return (
    <>
      {children}
      {process.env.NEXT_PUBLIC_AI_ASSISTANT_ENABLED === 'true' && (
        <CustomAssistant deliveries={deliveries} />
      )}
    </>
  )
}

export default AppComponent
